import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { campsenum } from '../../../../models/enums.generated';
import { camps } from '../../../../models/models.generated';
import { CampsEnumTranslationService } from '../../../../services/camps-enum-translation.service';
import { CampsDetailsFormStateService } from '../camp-details-form-state-service';
@Component({
    selector: 'app-camp-basic-info',
    templateUrl: './camp-basic-info.component.html',
    styleUrls: ['./camp-basic-info.component.scss'],
    standalone: false
})
export class CampBasicInfoComponent implements OnInit {
  
    @Input() public form : UntypedFormGroup;

    @Input() context: camps.CampDefinitionCreationContext;

    constructor(public state : CampsDetailsFormStateService, private enumTranslation : CampsEnumTranslationService) { 

    }

    ngOnInit(): void {
    }

    public get categoryForm(): UntypedFormGroup {
        return this.form.controls['category'] as UntypedFormGroup;
    }

    public edit(){
        this.state.markAsEdited(this.form);
    }

    public get isOtherItemEdited(){
        return this.state.isOtherItemEdited(this.form);
    }

    public translateStatus(status: campsenum.CampStatus){
        return this.enumTranslation.campStatus(status);
    }

    public translateReservationDaysAheadLimitVariant(variant: campsenum.ReservationDaysAheadLimitVariant){
        return this.enumTranslation.reservationDaysAheadLimitVariant(variant);
    }

    public get isChildcareCamp(){
        return this.state.isChildcareCamp();
    }

    public get campTypeLabel(){
        return this.enumTranslation.campType(this.state.campType);
    }

}
